import { useEffect, useState } from 'react'

import { getExperiment } from '@/helpers/getOptimizeExperiment'
import {
  ARRIVAL_DATE_EXPERIMENT_ID,
} from '@/services/Configuration'
import { error } from '@/services/Log'

const useAdjustArrivalDate = () => {
  const [shouldAdjustArrivalDate, setShouldAdjustArrivalDate] = useState(false)
  useEffect(() => {
    getExperiment({ experimentId: ARRIVAL_DATE_EXPERIMENT_ID })
      .then((variant) => {
        if (variant === '1') {
          setShouldAdjustArrivalDate(true)
        }
      })
      .catch(error)
  }, [])
  return shouldAdjustArrivalDate
}

export default useAdjustArrivalDate
